import React from 'react';
import { List, ListItem, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import Meta from '@bizapp-lp/pjb/organisms/Meta';
import { Complete } from '@bizapp-lp/pjb/templates/Complete';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiListItem-root': {
        display: 'block',
        textAlign: 'center',
      },
    },
  }),
);

const Page: React.FC = () => {
  const classes = useStyle();
  return (
    <>
      <Meta>
        <title>Project Board 社内向けサイトマップ</title>
      </Meta>
      <Complete
        heading1="Project Board 社内向けサイトマップ"
        heading2="各ページ確認用"
        description="完了系のページに直接飛べます"
      >
        <Container className={classes.root}>
          <List>
            <ListItem>
              <Link component={RouterLink} to="/pjb">
                Home(Landing Page)
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/pjb/application">
                購入のお手続き
              </Link>
            </ListItem>
            <ListItem>
              <Link
                component={RouterLink}
                to="/pjb/application?step=2"
                state={{ valid: true }}
              >
                購入のお手続き Step2
              </Link>
            </ListItem>
            <ListItem>
              <Link
                component={RouterLink}
                to="/pjb/application?step=3"
                state={{ valid: true }}
              >
                購入のお手続き Step3 (アンケート)
              </Link>
            </ListItem>
            <ListItem>
              <Link
                component={RouterLink}
                to="/pjb/complete-application"
                state={{ valid: true }}
              >
                購入のお手続き 完了
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/pjb/document-claim">
                資料請求
              </Link>
            </ListItem>
            <ListItem>
              <Link
                component={RouterLink}
                to="/pjb/complete-document-claim"
                state={{ valid: true }}
              >
                資料請求 完了
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/pjb/trial-application">
                無料トライアルお申し込み
              </Link>
            </ListItem>
            <ListItem>
              <Link
                component={RouterLink}
                to="/pjb/complete-trial-application"
                state={{ valid: true }}
              >
                無料トライアルお申し込み 完了
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/pjb/contact">
                お問い合わせ
              </Link>
            </ListItem>
            <ListItem>
              <Link
                component={RouterLink}
                to="/pjb/complete-contact"
                state={{ valid: true }}
              >
                お問い合わせ 完了
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/pjb/service-spec">
                pjb サービス仕様書
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/pjb/trial-spec">
                pjb トライアルサービス仕様書
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/pjb/invalid">
                無効なページ
              </Link>
            </ListItem>
          </List>
        </Container>
      </Complete>
    </>
  );
};

const Sitemap = React.memo(Page);
export default Sitemap;
